import React from 'react';
import StylistListing from '../modules/StylistListing/StylistListing';

function StylistsPage(){
  return <StylistListing/>
}

export default StylistsPage;